import { render, staticRenderFns } from "./PropsTable.vue?vue&type=template&id=457c9825&"
import script from "./PropsTable.vue?vue&type=script&lang=ts&"
export * from "./PropsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports